import styled from 'styled-components';

import {
  centeredGridColumns,
  getGridBase,
  getThemeColor,
  media,
} from '@utils/styled';

import Typography from '@common/components/Typography';

export const GiftCardHeroWrapper = styled.div`
  img {
    object-position: 50% 100%;
  }
`;

export const Title = styled(Typography).attrs({
  customAs: 'h1',
  variant: 'h2',
})`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 3)};
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 2)};
`;

export const Section = styled.section`
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 2)};

  & + & {
    border-top: 1px solid ${getThemeColor('bluegrey.90')};
  }
`;

export const SectionTitle = styled.h2`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 2)};
  ${({ theme }) => theme.getFluidAttribute('margin-bottom', 3.5, 5)}
  ${({ theme }) => theme.getFluidAttribute('font-size', 2.7, 2.8)}
  font-weight: 700;
  line-height: 3rem;
`;

export const GiftCardsPurchaseWrapper = styled.div`
  ${getGridBase(12)};
`;

export const GiftCardsPurchaseContent = styled.div`
  grid-column: ${centeredGridColumns(12)};
  max-width: 100%;

  ${media.from640up`
    grid-column: ${centeredGridColumns(10)};
  `}

  ${media.from1200up`
    grid-column: ${centeredGridColumns(8)};
  `}
`;
